import { FileWithPath } from 'react-dropzone';
import { UPSERT_DOCUMENT } from '../api';
import { apiURL } from '../config';
import { UpsertDocumentInput } from '../components/types';
import { newRelicNoticeError } from '../tracking/newrelic';


export const useUpsertDocument = () => {

  const upsertDocument = async (file: FileWithPath, input: any) => {
    try {
      const formData = new FormData();
      formData.append(
        'operations',
        JSON.stringify({
          query: UPSERT_DOCUMENT,
          variables: {
            input,
            file,
          },
        })
      );
      formData.append(
        'map',
        JSON.stringify({
          0: ['variables.file'],
        })
      );
      formData.append('0', file);

      const fetchResult = await fetch(apiURL, {
        method: 'POST',
        body: formData,
      });
      const response = await fetchResult.json();
      return response?.data?.upsertDocument?.document;
    } catch (error) {
      console.error(error);
      newRelicNoticeError(error as Error, { action: 'upsertDocument' });
      throw (error);
    }
  };

  return {
    upsertDocument,
  };
};
